@if (d) {
    <qp-table-data
        [nullValues]="nullValues"
        [data]="
            [
                { k: 'Lac',    v: d.lac    },
                { k: 'RxQual', v: d.rxqual }
            ]">
    </qp-table-data>
}